import { useState } from "react";
import CustimizationDiamond from "./CustimizationDiamond";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function CustomizationSection() {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation("customizationsection"); // Import the namespace

  const handleCustomizeClick = (option) => {
    if (option === "Jewellery") {
      navigate("/contactus");
    }
    setShowPopup(option === "Diamond");
  };

  return (
    <div className="flex flex-col md:flex-row w-full h-screen items-center justify-center md:space-x-8 space-y-8 md:space-y-0 p-4 z-10">
      {/* Diamond Customization */}
      <div className="relative flex flex-col items-center w-full md:w-1/2">
        <div className="relative w-full">
          <img
            src="/assets/images/section03_05.jpg"
            alt="Natural Diamond"
            className="w-full h-auto max-h-96 object-cover"
          />
          <button
            onClick={() => handleCustomizeClick("Diamond")}
            className="absolute bg-transparent border-2 border-white bottom-4 left-1/2 transform -translate-x-1/2 px-6 py-2 text-white rounded-lg hover:bg-gray-700"
          >
            {t("diamondCustomization")}
          </button>
        </div>
      </div>

      {/* Jewellery Customization */}
      <div className="relative flex flex-col items-center w-full md:w-1/2">
        <div className="relative w-full">
          <img
            src="/assets/images/section03_02.jpg"
            alt="Jewellery"
            className="w-full h-auto max-h-96 object-cover"
          />
          <button
            onClick={() => handleCustomizeClick("Jewellery")}
            className="absolute bg-transparent border-2 border-white bottom-4 left-1/2 transform -translate-x-1/2 px-6 py-2 text-white rounded-lg hover:bg-gray-700"
          >
            {t("jewelleryCustomization")}
          </button>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-2xl">
            <h2 className="text-2xl font-bold mb-4">{t("popupTitle")}</h2>
            <CustimizationDiamond setShowPopup={setShowPopup} />
            <button
              onClick={() => setShowPopup(false)}
              className="mt-4 px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700"
            >
              {t("popupClose")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomizationSection;
